export class PadBack {
    constructor(x, pads, mode, value) {
        this.x = x;
        this.pads = pads;
        this.mode = mode;
        this.value = value;
    }
    backward(grad) {
        throw new Error('Backward pass not implemented for pad');
    }
    delete() {
        if (!this.x.isLeaf()) {
            this.x.delete();
        }
    }
}
//# sourceMappingURL=padBack.js.map